class GlobalParams {
    constructor() {
        this.options = {
            blur_scale: 150,
            // film_grain: .4,
            film_grain: .1,
            iterations_poisson: 16,
            mouse_force: 3,
            resolution: .25,
            cursor_size: 100,
            // isBounce: false,
            isBounce: true,
            dt: .016666666,
            fluidDecay: .99,
            BFECC: true,
            colorType:0.0,
        },
        this.init()
    }
    init() {}
}
export const globalParams = new GlobalParams;